import { render, staticRenderFns } from "./documents.vue?vue&type=template&id=7c2c420a&scoped=true"
import script from "./documents.vue?vue&type=script&lang=js"
export * from "./documents.vue?vue&type=script&lang=js"
import style0 from "./documents.vue?vue&type=style&index=0&id=7c2c420a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2c420a",
  null
  
)

export default component.exports